export { MovieList } from './MovieList';

export { MovieCard } from './MovieCard/MovieCard';
